import { langSegment } from '@tmf-ui-routes/i18n-segments/lang-segment.i18n-segment';
import { notFoundI18nSegment } from '@tmf-ui-routes/i18n-segments/not-found.i18n-segment';

export function notFoundRoutePath(): string {
  return `/${langSegment()}/${notFoundI18nSegment()}/`;
}
